/* unplugin-vue-components disabled */import script from "./multi-column-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./multi-column-menu.vue?vue&type=script&setup=true&lang=ts"

import "./multi-column-menu.vue?vue&type=style&index=0&id=77850960&lang=scss"

const __exports__ = script;

export default __exports__